import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import sessionStorageService from "src/services/sessionStorageService";

const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Tell RouteChangeListener not to record this 404/access-denied page as the
    // resume target.
    sessionStorageService.setItem("storeLastLocation", "true");
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <h4 className="alert-heading">Access Denied!</h4>
      <div style={{ color: "red" }}>
        You do not have access to this page. Please contact your administrator.
      </div>
      <button className="btn btn-secondary" onClick={goBack}>
        Go Back
      </button>
    </>
  );
};

export default NotFound;
